// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.h-btn[data-v-01441c81] {\r\n  height: 40px;\n}\r\n", ""]);
// Exports
module.exports = exports;
